/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Media_Upload_Too_ManyInputs */

const vi_media_upload_too_many = /** @type {(inputs: Media_Upload_Too_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mỗi lần chỉ tải được tối đa ${i?.max} file. Hãy chia nhỏ rồi tải lại.`)
};

/**

* @param {Media_Upload_Too_ManyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_upload_too_many = /** @type {((inputs: Media_Upload_Too_ManyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Upload_Too_ManyInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_upload_too_many(inputs)
});